import type { Notification } from '@nuxt/ui/dist/runtime/types/notification'

export const toastSuccess = (options: Partial<Notification>): void => {
  toast().add({ ...options, timeout: 2 * 1000, color: 'green' })
}
